import type { Routes } from '@angular/router';

export const FUEL_POLICY_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./fuel-policy.component').then((m) => m.FuelPolicyComponent),
  },
] as const;
